import {Component, EventEmitter, Input, Output} from "@angular/core";
import {VDateRange} from "../shipper";
import {NgForOf} from "@angular/common";


@Component({
	selector: 'date-range',
	standalone: true,
	imports: [
		NgForOf
	],
	template: `
        <select class="form-control form-control-sm" (change)="onSelect($event)">
            <option *ngFor="let r of ranges" [value]="r.range" [selected]="r.range == default">{{ r.label }}</option>
        </select>
	`
})
export class IsfDaterangePicker{

	ranges:Array<{range:VDateRange, label:string}> = [
		{range: 'LAST_30', label: 'Last 30 Days'},
		{range: 'LAST_60', label: 'Last 60 Days'},
		{range: 'LAST_90', label: 'Last 90 Days'},
		{range: 'LAST_120', label: 'Last 120 Days'},
		{range: 'ALL', label: 'All Dates'}
	];
	
	
	@Input()
	default:VDateRange = "LAST_60";
	
	@Output()
	selected:EventEmitter<VDateRange> = new EventEmitter();
	
	
	onSelect(e:any){
		this.selected.emit(e.target.value);
	}
	
}
